import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
    fetchExternalClientDetails,
    checkIsWBSEValid
} from "../../../redux/fui/index";
import {
    Grid,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Typography,
    Paper
} from "@material-ui/core";
import { useDebounce } from "../../../helper/customizedHooks";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';

const aSelectedInstanceFields = {
    DMSId: { type: "string", fieldName: "dmsId" },
    ClientName: { type: "string", fieldName: "clientName" },
    // DeployRegion: { type: "object", fieldName: "deployRegion" },
    SAPContractID: { type: "object", fieldName: "sapContractId" },
    AaamPlatformType: { type: "object", fieldName: "aaamPlatformType" },
};

// Model configuration based on region
const modelConfig = {
    "Sydney": ["sonnet-4", "sonnet-4.5"],
    "frankfurt": ["sonnet-4", "sonnet-4.5"],
    "virginia": ["sonnet-4", "sonnet-4.5"]
};

const BedrockPlatform = ({
    values,
    updateBRForm,
    updateASelectedInstanceByField,
    createdBy,
    checkDomainAvaliable,
    isRootExist,
    setIsAllValid,
    selectedEnvironment,
    getSelectedEnvironment,
    minDate,
    maxDate,
    getServiceEndDate,
    isServiceEndDateInvalid,
    getNotesValue,
    notesValidations,
    configurationType,
    classes,
    history,
    vendorName,
    email,
    idToken,
    isExternalClientLoading,
    externalClientData,
    externalClientError,
    fetchExternalClientDetails,
    isLoading,
    checkIsWBSEValid,
    isWBSEValid,
    formClickSubmit
}) => {
    const config = configurationType === "quick";
    const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
    const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
    const [domainContextRoot, setDomainContextRoot] = useState("[__]");
    const [regionCode, setRegionCode] = useState("[__]");

    // Use enhanced validation hook with red borders and dialog management
    const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid);

    const getAvailableModels = () => {
        const selectedRegion = values.DeploymentRegion;
        if (selectedRegion && modelConfig[selectedRegion]) {
            return modelConfig[selectedRegion];
        }
        return [];
    };
 
    useEffect(() => {
        updateASelectedInstanceByField({
            field: "aaamPlatformType",
            value: {
                Value: "myWizard AiOps Plain Instance",
            },
        });
    }, []);

    useEffect(() => {
        if (config) {
            setDomainContextRoot("[__]");
            setRegionCode("[__]");
        }
    }, [config]);

    useEffect(() => {
        if (values.DeploymentRegion) {
            const availableModels = getAvailableModels();
            if (values.modelname && !availableModels.includes(values.modelname)) {
                updateBRForm("modelname", "");
            }
        }
    }, [values.DeploymentRegion]);

    useEffect(() => {
        const isValid =
            values.ClientName &&
            values.WBSEcode &&
            values.PrimaryPoc &&
            values.SecondaryPoc &&
            values.Environment &&
            values.DeploymentRegion &&
            values.ContractId &&
            values.modelname &&
            isWBSEValid;

        setIsAllValid && setIsAllValid(isValid);
    }, [values, isWBSEValid, setIsAllValid]);

    updateBRForm("VendorName", vendorName);
    updateBRForm("ConfigurationType", configurationType);

    const handleChange = (event, fieldName) => {
        const value = event.target.value;
        updateBRForm(fieldName, value);

        if (fieldName === "WBSEcode") {
            const isWBSEFormatValid = value && value.length > 0;
            if (isWBSEFormatValid) {
                checkIsWBSEValid(value);
            }
        }

        if (fieldName === "ContractId" || fieldName === "SAPContractID") {
            let length = value.length;
            setSapContractCodeLength(length);
            if (length === 10) {
                fetchExternalClientDetails(value);
            }
        }

        if (aSelectedInstanceFields[fieldName]) {
            const afieldDetails = aSelectedInstanceFields[fieldName];
            afieldDetails.type === "string" &&
                updateASelectedInstanceByField({
                    field: afieldDetails.fieldName,
                    value,
                });
            afieldDetails.type === "object" &&
                updateASelectedInstanceByField({
                    field: afieldDetails.fieldName,
                    value: { Value: value },
                });
        }
    };

    const validateInputFields = (step) => {
        // If not final submit, allow navigation (no validation)
        if (step !== 'submit') {
            return true;
        }

        let ispass = true;
        const missingFields = [];

        // Final submit validation - validate ALL fields
        const allFieldsRequired = [
            'WBSEcode',
            'ClientName',
            'SecondaryPOC',
            'Environment',
            'DeploymentRegion',
            'modelname',
            'RequestNotes'
        ];

        // Add conditional required fields
        if (!config) {
            allFieldsRequired.push('SAPContractID');
        }

        // Check for missing fields (basic empty validation - red borders handled by hook)
        for (const fieldname of allFieldsRequired) {
            if (fieldname === "WBSEcode") {
                // WBSE validation: empty OR API validation failed
                if (!values[fieldname] || values[fieldname] === "" || !isWBSEValid) {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            } else if (values[fieldname] === "" || values[fieldname] === undefined || values[fieldname] === null) {
                missingFields.push(fieldname);
                ispass = false;
            }
        }

        // Prepare form data for submission
        const formData = {
            sapContractId: values.SAPContractID || "**********",
            DeploymentRegion: values.DeploymentRegion || "",
            wbseCode: values.WBSEcode || "",
            primaryPoc: email.split("@")[0] || "",
            SecondaryPOC: values.SecondaryPOC || "",
            modelname: values.modelname || "",
            Environment: values.Environment || "",
            ClientName: values.ClientName || "",
            notes: values.RequestNotes || "",
            ClientType: !config ? "External" : "Internal"
        };

        // Use the hook to handle validation results (red borders + dialog)
        handleValidationResult(ispass, missingFields, () => formClickSubmit(formData));
        return ispass;
    }

    return (
        <>
            <GeneralForm
            FormId={12}
            validateInputFields={validateInputFields}
            currentFormData={{
                sapContractId: values.SAPContractID || "",
                DeploymentRegion: values.DeploymentRegion || "",
                wbseCode: values.WBSEcode || "",
                SecondaryPOC: values.SecondaryPOC || "",
                modelname: values.modelname || "",
                Environment: values.Environment || "",
                ClientName: values.ClientName || "",
                notes: values.RequestNotes || "",
            }}
            ProvisionDetails={
                <Paper elevation={2} style={{ padding: 24, margin: "0" }}>
                    <Typography
                        variant="h5"
                        gutterBottom
                        color="primary"
                        style={{ margin: '10px 0' }}
                    >
                        Bedrock Platform Configuration Details
                    </Typography>

                    <Grid container spacing={2}>
                        {/* Row 1: SAP Contract ID and WBSE Code */}
                        {!config &&
                            <Grid item xs={6}>
                                {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                            </Grid>
                        }
                        <Grid item xs={6}>
                            {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                        </Grid>

                        {/* Row 2: Client Name and Secondary POC */}
                        <Grid item xs={6}>
                            {FormField.ClientNamePlatformInternal(handleChange, values)}
                        </Grid>
                        <Grid item xs={6}>
                            {FormField.SecondaryContactbedrock(handleChange, values, config)}
                        </Grid>
                        <Grid item xs={6}>
                            {PlatformFormField.BedrockPlatformEnvironmentField(values, handleChange)}
                        </Grid>

                        {/* Row 4: Region and Model ID */}
                        <Grid item xs={6}>
                            {PlatformFormField.BedrockPlatformRegion(values, handleChange)}
                        </Grid>

                        <Grid item xs={6}>
                            {PlatformFormField.BedrockPlatformModel(values, handleChange)}
                        </Grid>

                        {/* Row 5: Request Notes - Full Width with Increased Height */}
                        <Grid item xs={12}>
                            {PlatformFormField.RequestNotesPlatformField(
                                values,
                                handleChange,
                                notesValidations,
                                { style: { height: 120 } } // increased height
                            )}
                        </Grid>
                    </Grid>
                </Paper>
            }
            productname={"BedrockPlatform"}
            history={history}
        />

            {/* Validation Error Dialog */}
            <ValidationDialog
                open={showValidationDialog}
                onClose={closeDialog}
                errors={validationErrors}
                showStepNumbers={false}
            />
        </>
    );
};

const MSTP = (state) => ({
    isRootExist: state.fui.isRootExist,
    isWBSEValid: state.fui.isWBSEValid,
    values: state.fui.BRForm,
    configurationType: state.fui.configurationType,
    email: state.auth.userDetails.email,
    idToken: state.auth.idToken,
    externalClientData: state.fui.externalClientData,
    externalClientError: state.fui.externalClientError,
    isExternalClientLoading: state.fui.isExternalClientLoading,
    isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
    updateBRForm: fuiRedux.updateBRForm,
    updateASelectedInstanceByField: fuiRedux.updateASelectedInstanceByField,
    checkDomainAvaliable: fuiRedux.checkRootExisted,
    fetchExternalClientDetails,
    checkIsWBSEValid
})(withRouter(BedrockPlatform));
